import * as React from "react";

interface GenSearchBoxProps {
  resetListPages: () => void;
  readListPage: () => void;
  setListSearch: (searchValue: string) => void;
  search?: string;
  placeholder?: string
}

export default function GenSearchBox(
  {
    resetListPages,
    readListPage,
    setListSearch,
    search,
    placeholder,
  }: GenSearchBoxProps,
) {
  const searchTimerRef = React.useRef<ReturnType<typeof setTimeout>>();

  React.useEffect(() => {
    const searchTimer = searchTimerRef.current;
    if (searchTimer) { clearTimeout(searchTimer); }
  }, []);

  const updateSearchWithTimer = React.useCallback(() => {
    resetListPages();
    readListPage();
    searchTimerRef.current = undefined;
  }, [resetListPages, readListPage]);

  const handleSearchChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setListSearch(e.target.value);

    const searchTimer = searchTimerRef.current;
    if (searchTimer) { clearTimeout(searchTimer); }
    searchTimerRef.current = setTimeout(updateSearchWithTimer, 750);
  }, [setListSearch, updateSearchWithTimer]);

  const handleSearchKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const searchTimer = searchTimerRef.current;
      if (searchTimer) { clearTimeout(searchTimer); }
      searchTimerRef.current = undefined;

      updateSearchWithTimer();
      e.preventDefault();
    }
  }, [updateSearchWithTimer]);

  return (
    <form className="gen-search-box" role="search">
      <input
        type="search"
        placeholder={placeholder || "Search..."}
        value={search || ""}
        onChange={handleSearchChange}
        onKeyDown={handleSearchKeyDown}
      />
    </form>
  );
}
